import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, imgUrl } from "../lib/api";

const Journal = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/journal")
      .then((r) => setPosts(r.data))
      .finally(() => setLoading(false));
  }, []);

  const formatDate = (iso) => {
    try {
      return new Date(iso).toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      });
    } catch {
      return "";
    }
  };

  return (
    <div className="px-6 md:px-12 lg:px-20 py-16 md:py-24" data-testid="page-journal">
      <div className="max-w-3xl">
        <div className="label-eyebrow mb-3">The Journal</div>
        <h1 className="font-serif-display text-5xl md:text-6xl text-[#1A1F1B]">
          Studio notes, in slow order.
        </h1>
        <p className="mt-6 text-[#4E5C50] leading-relaxed">
          Process notes, new work, quiet observations from the studio.
        </p>
      </div>

      {loading ? (
        <div className="py-32 text-center text-[#849383]" data-testid="journal-loading">
          Loading journal…
        </div>
      ) : posts.length === 0 ? (
        <div className="py-32 text-center text-[#849383]" data-testid="journal-empty">
          The first entry is on its way.
        </div>
      ) : (
        <div
          className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10"
          data-testid="journal-grid"
        >
          {posts.map((p) => (
            <Link
              key={p.id}
              to={`/journal/${p.slug}`}
              className="art-card group"
              data-testid={`journal-item-${p.slug}`}
            >
              <div className="overflow-hidden bg-[#EFECE5] border border-[#D8D3CC]">
                <img
                  src={imgUrl(p.cover_image_url)}
                  alt={p.title}
                  loading="lazy"
                  className="w-full aspect-[4/5] object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                />
              </div>
              <div className="mt-5">
                <div className="text-xs uppercase tracking-[0.22em] text-[#849383]">
                  {formatDate(p.created_at)}
                </div>
                <h2 className="font-serif-display text-2xl md:text-3xl text-[#1A1F1B] mt-2 leading-tight">
                  {p.title}
                </h2>
                {p.excerpt && (
                  <p className="mt-3 text-sm text-[#4E5C50] leading-relaxed line-clamp-3">
                    {p.excerpt}
                  </p>
                )}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default Journal;
